module.exports = __webpack_public_path__ + "static/media/open-icon-white.398da73a.svg";